export default __webpack_public_path__ + "static/media/class_negative.237be3c7.svg";